// extracted by mini-css-extract-plugin
export default {"header":"Header_header__uIctP","title":"Header_title__65I7s","headerMenu":"Header_headerMenu__7iSGD","group":"Header_group__7ckTw"};